import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Response } from '../../../../_shared/models';
import { PaginatedResult } from '../../../../_shared/models/paginated-result.model';
import { AddPartRequestNoteRequest, ApproveWorkOrderPartsRequest, IssuePartsRequest, PartRequest, PartRequestNote, PartsRequestFilterRequest, RejectWorkOrderPartsRequest, ResetWorkOrderPartsRequest } from '../models/part-request.model';

@Injectable({
  providedIn: 'root'
})
export class PartsRequestService {
  private http = inject(HttpClient);

  getPartsRequestsAsync(request: PartsRequestFilterRequest, cancellation: Subject<void>): Promise<Response<PaginatedResult<PartRequest>>> {
    return firstValueFrom(this.http.post<Response<PaginatedResult<PartRequest>>>(`${environment.apiEndpoint}/parts/work-order-parts-requests/filter`, request).pipe(takeUntil(cancellation)));
  }

  rejectWorkOrderPartsAsync(request: RejectWorkOrderPartsRequest): Promise<Response<boolean>> {
    return firstValueFrom(
      this.http.put<Response<boolean>>(`${environment.apiEndpoint}/parts/work-order-parts-requests/reject`, request)
    );
  }

  approveWorkOrderPartsAsync(request: ApproveWorkOrderPartsRequest): Promise<Response<boolean>> {
    return firstValueFrom(
      this.http.put<Response<boolean>>(`${environment.apiEndpoint}/parts/work-order-parts-requests/approve`, request)
    );
  }

  resetWorkOrderPartsAsync(request: ResetWorkOrderPartsRequest): Promise<Response<boolean>> {
    return firstValueFrom(
      this.http.put<Response<boolean>>(`${environment.apiEndpoint}/parts/work-order-parts-requests/reset`, request)
    );
  }

  getPartRequestNotesAsync(partRequestId: number): Promise<Response<PartRequestNote[]>> {
    return firstValueFrom(
      this.http.get<Response<PartRequestNote[]>>(`${environment.apiEndpoint}/parts/work-order-parts-requests/${partRequestId}/notes`)
    );
  }

  addPartRequestNoteAsync(partRequestId: number, request: AddPartRequestNoteRequest): Promise<Response<void>> {
    return firstValueFrom(
      this.http.post<Response<void>>(`${environment.apiEndpoint}/parts/work-order-parts-requests/${partRequestId}/notes`, request)
    );
  }

  issuePartsAsync(request: IssuePartsRequest): Promise<Response<boolean>> {
    return firstValueFrom(
      this.http.put<Response<boolean>>(`${environment.apiEndpoint}/parts/work-order-parts-requests/issue`, request)
    );
  }
}